<template>
  <a-config-provider :locale="locale" id="app">
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('base/index')
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      locale: zhCN,
    };
  },
  mounted() {
    this.refresh()
  },
  methods: {
    ...mapActions({
      refresh: 'refresh'
    }),
  }
}
</script>

<style>
#app {
  font-size: 16px;
}
</style>
